import React, { lazy } from "react";
import { defer } from "react-router-dom";
import RouteLoader from "../UI/RouteLoader";
import { getUserRequest } from "../../requests/users";
import { withSuspense } from "./routeHelpers";

// Instructor components
const Instructors = lazy(
  () =>
    import(/* webpackChunkName: "instructors" */ "../Instructors/Instructors")
);
const Instructor = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/Instructor"
    )
);
const InstructorOverview = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/InstructorOverview/InstructorOverview"
    )
);
const InstructorProfile = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/InstructorProfile/InstructorProfile"
    )
);
const InstructorStudents = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/InstructorStudents/InstructorStudents"
    )
);
const InstructorCourses = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/InstructorCourses/InstructorCourses"
    )
);
const InstructorNew = lazy(
  () =>
    import(
      /* webpackChunkName: "instructors" */ "../Instructors/Instructor/InstructorNew"
    )
);

export default [
  {
    path: "/instructors",
    element: withSuspense(Instructors),
  },
  {
    path: "/instructors/new",
    element: withSuspense(InstructorNew),
  },
  {
    path: "/instructors/:userId",
    element: (
      <RouteLoader>
        {(loader) => withSuspense(<Instructor instructor={loader?.data} />)}
      </RouteLoader>
    ),
    id: "user",
    loader: ({ params }) => {
      return defer({
        data: getUserRequest({ userId: params.userId }),
      });
    },
    children: [
      {
        path: "/instructors/:userId/overview",
        element: withSuspense(InstructorOverview),
      },
      {
        path: "/instructors/:userId/profile",
        element: withSuspense(InstructorProfile),
      },
      {
        path: "/instructors/:userId/students",
        element: withSuspense(InstructorStudents),
      },
      {
        path: "/instructors/:userId/courses",
        element: withSuspense(InstructorCourses),
      },
    ],
  },
];
